import AccessControlDialog from "@/components/call/access-controls/shared/dialog";
import { AccessControlCloseGate } from "@EspaceParkQC/sdk-call-center";
import { toast } from "@EspaceParkQC/sdk-react";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";

interface CloseGateProps {
  /** Primary (filled) while the gate is held, since Close is then the only way to release it. */
  variant?: "primary" | "default";
}

export default function CloseGate({ variant = "default" }: CloseGateProps) {
  const { t } = useTranslation("main");

  function handleSubmit() {
    toast.loading(t("intercom.access-controls.close-gate.submitting"));
  }

  function handleSuccess() {
    toast.success(t("intercom.access-controls.close-gate.success"));
  }

  function handleError(error: unknown) {
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error(JSON.stringify(error));
    }
  }

  return (
    <AccessControlCloseGate
      onGateError={handleError}
      onGateSuccess={handleSuccess}
      render={({ button, form }) => (
        <AccessControlDialog
          variant={variant}
          title={t("intercom.access-controls.close-gate.title")}
          description={t("intercom.access-controls.close-gate.description")}
          icon={<Lock className="size-4" />}
          buttonProps={button}
          formProps={form}
          onSubmit={async () => handleSubmit()}
          formOnSubmit={async (value?: string | number) => {
            if (typeof value === "string") {
              await form.onSubmit(value);
            }
          }}
        />
      )}
    />
  );
}
